import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'material-ui/styles/withStyles';
import styles from './styles';

const currentYear = new Date().getFullYear();

const Footer = props => (
	<footer className={props.classes.container}>
		<div>
			<p>
				Copyright © {currentYear} Juvora Ltd, an <a href="https://invibio.com/" target="_blank" rel="noopener noreferrer">Invibio</a> company. All rights reserved
			</p>
		</div>
		<p>
			By accessing this service you agree to our <a href="/terms-and-conditions">Terms and Conditions</a> and <a href="/privacy-policy">Privacy Policy</a>
		</p>
	</footer>
);

Footer.propTypes = {
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Footer);



// WEBPACK FOOTER //
// ./src/client/components/main/footer/index.jsx